module.exports = __webpack_public_path__ + "static/design-animal.978e4b20.png";